<template>
  <tr>
    <td
      class="boss-table-data"
      data-test="job-id"
    >
      {{ job.displayId || '新規' }}
    </td>
    <td
      class="boss-table-data"
      data-test="job-admin-name"
    >
      {{ job.adminName }}
    </td>
    <td
      class="boss-table-data left"
      data-test="job-name"
    >
      {{ job.name }}
    </td>
    <td
      class="boss-table-data"
      data-test="publish-plan"
    >
      {{ job.publishPlan }}
    </td>
    <td class="boss-table-data">
      <div>
        <button
          class="boss-button"
          data-test="job-preview-button"
          @click="windowOpenPreview('jobPrePublishedPreview')"
        >
          求人
        </button>
      </div>
      <div class="pega-mt-05">
        <button
          class="boss-button pega-width-5-5rem"
          data-test="job-search-preview-button"
          @click="windowOpenPreview('jobSearchPrePublishedPreview')"
        >
          検索一覧
        </button>
      </div>
    </td>
    <template v-if="isShowOptions">
      <job-pre-published-option-sell
        :rowspan="optionsRowspan"
        :photoclip-ids="photoclipIds"
        :interview-ids="interviewIds"
      />
    </template>
  </tr>
</template>

<script>
import JobPrePublishedOptionSell from '@/components/atoms/JobPrePublishedOptionSell'

export default {
  components: {
    JobPrePublishedOptionSell
  },
  props: {
    job: {
      type: Object,
      required: true
    },
    isShowOptions: {
      type: Boolean,
      required: true
    },
    optionsRowspan: {
      type: Number,
      required: true
    },
    photoclipIds: {
      type: Array,
      required: true
    },
    interviewIds: {
      type: Array,
      required: true
    }
  },
  methods: {
    windowOpenPreview (name) {
      const routeData = this.$router.resolve({ name: name, params: { jobId: this.job.id } })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
